if (!Enum) {
    var Enum = {};
}

Enum.REFERRAL_TYPE = {
    E_REFERRAL: 'E_REFERRAL',
    DIAGNOSTIC: 'DIAGNOSTIC',
    SPECIALIST: 'SPECIALIST',
    HOSPITAL: 'HOSPITAL',
    LABORATORY: 'LABORATORY',
    ALAB: 'ALAB'
};

Object.freeze(Enum.REFERRAL_TYPE);
